<template>
  <div>
    <!-- v-for="(item, index) in 6"   -->
    <div
      style="
        display: flex;
        margin-bottom: 0.2rem;
        justify-content: space-between;
      "
    >
      <div style="display: flex">
        <img
          style="
            width: 0.5rem;
            height: 0.5rem;
            background: #ccc;
            border-radius: 50%;
            margin-right: 0.12rem;
          "
          :src="item.avatar ? item.avatar : require('@/assets/logo.png')"
        />
        <div
          style="
            height: 0.5rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 1.52rem;
          "
        >
          <div style="font-size: 0.16rem; color: #333333">
            {{ item.userName }}
          </div>
          <div
            style="
              color: #015243;
              background: #e1fefc;
              padding: 0.02rem 0.12rem;
              box-sizing: border-box;
              font-size: 0.12rem;
            "
          >
            标识山西认证导演
          </div>
        </div>
      </div>

      <div
        style="
          margin-left: 0.25rem;
          height: 0.5rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        "
      >
        <div style="font-size: 0.12rem">
          <span>创作</span>
          <span style="color: #000000">&nbsp;0&nbsp;</span>
          <span>&nbsp;|&nbsp;</span>
          <span>粉丝</span>
          <span style="color: #000000">&nbsp;{{ item.fansNumber }}&nbsp;</span>
          <span>&nbsp;|&nbsp;</span>
          <span>签单</span>
          <span style="color: #000000"
            >&nbsp;{{ item.signingNumer }}&nbsp;</span
          >
        </div>
        <div style="font-size: 0.12rem" v-if="item.remark">
          {{ item.remark }}
        </div>
        <div style="font-size: 0.12rem" v-else>暂无简介</div>
      </div>
      <div>
        <el-radio-group v-if="type == 0" v-model="radio" class="ml-4">
          <el-radio label="1" size="small"> </el-radio>
        </el-radio-group>
        <div v-else>
          <div class="topBtn" @click="Details(item)">进入主页</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, nextTick } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
const radio = ref("");
const yyy = defineProps({
  item: { type: Object, default: {} },
  type: { type: Number, default: 0 },
});

const Details = (item) => {
  router.push({
    path: "/ShadowComposerHomepage",
    query: { id: item.userId },
  });
};

const init = (e) => {
  // console.log(222222222);
  radio.value = "";
};
defineExpose({ init, radio });
</script>

<style scoped>
/deep/.el-radio__label {
  color: #333 !important;
}

/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #c01a26 !important;
  background: #c01a26 !important;
}
/deep/ .el-radio.el-radio--small .el-radio__label {
  opacity: 0;
}
.topBtn {
  height: 0.33rem;
  margin-top: 0.05rem;
  line-height: 0.33rem;
  font-size: 0.14rem;
  padding: 0 0.24rem;
  text-align: center;
  color: #333333;
  background: #ffffff;
  border-radius: 0.1rem;
  opacity: 1;
  color: #ffff;
  background: #c01a26;
  margin-left: 0.2rem;
}

/deep/ .el-radio.el-radio--small .el-radio__inner {
  width: 20px;
  height: 20px;
}
/* /deep/ .el-radio__inner {
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  width: 14px;
  height: 14px;
  background-color: #fff;
  cursor: pointer;
  box-sizing: border-box;
} */

/deep/ .el-radio__input.is-checked .el-radio__inner::after {
  content: "";
  width: 8px;
  height: 5px;
  border: 2px solid white;
  border-top: transparent;
  border-right: transparent;
  text-align: center;
  display: block;
  position: absolute;
  top: 3.5px;
  left: 3.5px;
  transform: rotate(-45deg);
  border-radius: 0px;
  background: none;
}
</style>
